/**
 * 获取url指定参数的值
 * @param key url参数名
 * @param url url，默认为当前页面url
 */
export function getUrlParam(name: string, url = window.location.href) {
  const urlSearchParams = new URL(url).searchParams;
  return urlSearchParams.get(name);
}

/**
 *
 *
 * @export
 * @param {*} name url参数名
 * @param {*} [url=window.location.href]  url，默认为当前页面url
 * @return {*} 匹配的搜索参数
 */
export function getUrlHash(name: string, url = window.location.href): string|null {
  const { hash } = new URL(url);
  const searchIndex = hash.indexOf('?');
  // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
  const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : '';
  const usp = new URLSearchParams(search);
  return usp.get(name);
}


/**
 *
 *
 * @export
 * @param {*} [url=window.location.href]
 * @return {*} 返回符合条件的字符或者空字符
 */
export function getUrlAdtag(url = window.location.href) {
  // adtag获取唯一配置 需兼容各类大小写：adtag、ADTAG、Adtag、adTag
  const conditions = [
    'adtag',
    'ADTAG',
    'Adtag',
    'adTag',
    'hottag',
    'HOTTAG',
    'HotTag',
    'hotTag',
  ];
  for (const key of conditions) {
    const tag = getUrlParam(key, url) || getUrlHash(key, url) || '';
    if (tag) return tag;
  }
}

/**
 * url添加参数
 * @param url url
 * @param name 参数名
 * @param value 参数值
 */
export function addUrlParam(url: string, name: string, value: any) {
  return addUrlParams(url, { [name]: value });
}

/**
 * url添加多个参数
 * @param url url
 * @param params 参数
 */
export function addUrlParams(url: string, params: Record<string, any>) {
  const urlObject = new URL(url);
  Object.keys(params).forEach((name) => {
    const value = params[name];
    if (urlObject.searchParams.has(name)) {
      urlObject.searchParams.delete(name);
    }
    urlObject.searchParams.append(name, value as string);
  });
  return urlObject.href;
}

/**
 * 去除URL中指定的参数
 * @param url url
 * @param name 参数名
 */
export function removeUrlParam(url: string, name: string) {
  return removeUrlParams(url, [name]);
}

/**
 * 去除URL中指定的参数
 * @param url url
 * @param params 参数列表
 */
export function removeUrlParams(url: string, params: string[]) {
  const urlObject = new URL(url);
  params.forEach((name) => {
    if (urlObject.searchParams.has(name)) {
      urlObject.searchParams.delete(name);
    }
  });
  return urlObject.href;
}

/**
 * url search params参数转化为Object
 * @param params url search params格式的字符串
 */
export function paramsToObject<T extends object = {}>(params: string) {
  const searchParams = new URLSearchParams(params);
  const result = {};
  for (const [key, value] of searchParams.entries()) {
    result[key] = value;
  }
  return result as T;
}

/**
 * Object转换为url search params数据
 * @param object Object类型数据
 */
export function objectToParams(object: object) {
  const searchParams = new URLSearchParams();
  Object.keys(object).forEach((name) => {
    searchParams.append(name, object[name]);
  });
  return searchParams.toString();
}
